<template>
    <div class="relative h-[500px] overflow-hidden">

        <!-- SLIDESHOW -->
        <Splide
            ref="splide"
            :options="splideOptions"
            aria-label="Pachamama Punta Chame"
            class="absolute inset-0 h-full"
            @splide:mounted="onSplideMounted"
            @splide:moved="onSlideMoved"
        >
            <SplideSlide
                v-for="(slide, index) in slides"
                :key="slide.id"
            >
                <!-- IMAGEN -->
                <div
                    v-if="slide.type === 'image'"
                    class="h-[500px] bg-cover bg-center bg-no-repeat"
                    :style="{
                        backgroundImage: `url(${slide.src})`,
                        backgroundPosition: slide.position
                    }"
                ></div>

                <!-- YOUTUBE -->
                <div
                    v-else-if="slide.type === 'youtube'"
                    class=" h-[500px] overflow-hidden bg-cover bg-black"
                >
                    <div
                        :id="`youtube-player-${index}`"
                        class="youtube-player"
                    ></div>
                    
                </div>
            </SplideSlide>
        </Splide>


        <!-- OVERLAY -->
        <div
            v-if="currentSlideType !== 'youtube'"  
            class="pointer-events-none absolute inset-0 z-10 bg-black/60"
        ></div> 


        <!-- CONTENIDO FIJO -->
        <div
            class="
                pointer-events-none
                absolute inset-0 z-20
                flex items-center justify-center
            "
        >
            <div
                v-if="currentSlideType !== 'youtube'"  
                class="px-6 text-center text-white md:px-12">

                <div class="flex items-center justify-center">
                    <img
                        src="/assets/images/pachamamaobc_logo_rectangle.png"
                        alt="Pachamama Punta Chame OBC"
                        class="h-40 w-auto"
                    >
                </div>
  
                <button
                    type="button"
                    class="
                        pointer-events-auto
                        mt-6 inline-block
                        rounded
                        border-2 border-neutral-50
                        px-6 pb-[6px] pt-2
                        text-xs font-medium uppercase
                        leading-normal text-neutral-50
                        transition duration-150 ease-in-out
                        hover:border-neutral-300
                        hover:text-neutral-200
                    "
                >
                    Donaciones
                </button>

            </div>
        </div>

    </div>
</template>


<script>
import {
    Splide,
    SplideSlide,
} from '@splidejs/vue-splide';

import '@splidejs/vue-splide/css';

export default {

    name: 'Cover',

    components: {
        Splide,
        SplideSlide,
    },

    data() {
        return {

            youtubePlayers: {},
            currentSlideType: '',
            splideInstance: null,

            slides: [
                {
                    id: 1,
                    type: 'image',
                    src: '/assets/images/pachamamaobc_chame_manglares_panama.jpg',
                    position: 'center center',
                },

                {
                    id: 2,
                    type: 'youtube',
                    videoId: 'hYvvgcgHRiI',
                },

                {
                    id: 3,
                    type: 'image',
                    src: '/assets/images/pachamamaobc_mangle_boton.jpg',
                    position: 'center center',
                },

                {
                    id: 4,
                    type: 'youtube',
                    videoId: 'wHpoBXhtXHw',
                },

                {
                    id: 5,
                    type: 'image',
                     src: '/assets/images/pachamamaobc_giras.jpg',
                    videoId: 'wHpoBXhtXHw',
                },
            ],

            splideOptions: {
                type: 'fade',

                rewind: true,

                autoplay: true,

                interval: 5000,

                speed: 1500,

                arrows: true,

                pagination: true,

                pauseOnHover: false,

                pauseOnFocus: false,

                drag: true,
            },
        };
    },


    mounted() {
        this.loadYouTubeApi();
    },


    beforeUnmount() {

        Object.values(this.youtubePlayers).forEach((player) => {

            if (player && player.destroy) {
                player.destroy();
            }

        });

    },


    methods: {

        /*
        |--------------------------------------------------------------------------
        | Cargar YouTube IFrame API
        |--------------------------------------------------------------------------
        */

        loadYouTubeApi() {

            /*
            * YouTube ya está cargado.
            */
            if (
                window.YT &&
                window.YT.Player
            ) {

                this.$nextTick(() => {
                    this.createYouTubePlayers();
                });

                return;
            }


            /*
            * Crear script solamente una vez.
            */
            if (
                !document.getElementById(
                    'youtube-iframe-api'
                )
            ) {

                const script =
                    document.createElement('script');

                script.id =
                    'youtube-iframe-api';

                script.src =
                    'https://www.youtube.com/iframe_api';

                document.head.appendChild(script);

            }


            /*
            * YouTube ejecutará esta función
            * cuando la API esté completamente lista.
            */
            const previousCallback =
                window.onYouTubeIframeAPIReady;


            window.onYouTubeIframeAPIReady = () => {

                if (
                    typeof previousCallback === 'function'
                ) {
                    previousCallback();
                }

                this.$nextTick(() => {

                    this.createYouTubePlayers();

                });

            };
        },


        /*
        |--------------------------------------------------------------------------
        | Crear players
        |--------------------------------------------------------------------------
        */

        createYouTubePlayers() {

            // La API de YouTube todavía no está disponible
            if (
                !window.YT ||
                !window.YT.Player
            ) {
                return;
            }

            this.slides.forEach((slide, index) => {

                if (slide.type !== 'youtube') {
                    return;
                }

                const elementId =
                    `youtube-player-${index}`;

                const element =
                    document.getElementById(elementId);

                if (!element) {
                    return;
                }

                // Ya existe
                if (this.youtubePlayers[index]) {
                    return;
                }

                this.youtubePlayers[index] =
                    new window.YT.Player(
                        elementId,
                        {
                            videoId: slide.videoId,
                            height: '100%',
                            width: '100%',

                            playerVars: {

                                autoplay: 0,

                                controls: 0,

                                mute: 1,

                                loop: 0,

                                rel: 0,

                                playsinline: 1,

                                modestbranding: 1,

                                origin: window.location.origin,
                            },

                            events: {

                                onReady: (event) => {

                                    event.target.mute();

                                    /*
                                    * Si este video pertenece
                                    * al slide actualmente visible,
                                    * iniciar reproducción.
                                    */
                                    if (
                                        this.splideInstance &&
                                        this.splideInstance.index === index
                                    ) {
                                        this.handleCurrentSlide(index);
                                    }

                                },

                                onStateChange: (event) => {

                                    this.onYouTubeStateChange(
                                        event,
                                        index
                                    );

                                },
                            },
                        }
                    );

            });
        },


        /*
        |--------------------------------------------------------------------------
        | Evento estado YouTube
        |--------------------------------------------------------------------------
        */

        onYouTubeStateChange(event, index) {

            if (!window.YT) {
                return;
            }


            /*
             * El video terminó
             */
            if (
                event.data ===
                window.YT.PlayerState.ENDED
            ) {

                const currentIndex =
                    this.splideInstance?.index;


                /*
                 * Solo avanzar si este sigue
                 * siendo el slide activo.
                 */
                if (currentIndex === index) {

                    this.splideInstance.go('>');

                }
            }

            /*
             * El video esta tocandose
             */
            if (
                event.data ===
                window.YT.PlayerState.PLAYING 
            ){
                setTimeout(this.stopVideo(index), 2000);
            }

        },

        stopVideo(index){
            this.youtubePlayers[index];
        },


        /*
        |--------------------------------------------------------------------------
        | Splide mounted
        |--------------------------------------------------------------------------
        */

        onSplideMounted(splide) {

            this.splideInstance = splide;

            this.$nextTick(() => {

                /*
                * Crear players solamente
                * si YouTube ya cargó.
                */
                if (
                    window.YT &&
                    window.YT.Player
                ) {
                    this.createYouTubePlayers();
                }

                /*
                * Procesamos el primer slide.
                */
                this.handleCurrentSlide(
                    splide.index
                );

            });
        },


        /*
        |--------------------------------------------------------------------------
        | Cambio de slide
        |--------------------------------------------------------------------------
        */

        onSlideMoved(splide, newIndex) {

            this.pauseAllVideos();

            this.handleCurrentSlide(
                newIndex
            );
        },


        /*
        |--------------------------------------------------------------------------
        | Procesar slide actual
        |--------------------------------------------------------------------------
        */

        handleCurrentSlide(index) {

            const slide =
                this.slides[index];

            if (!slide) {
                return;
            }

            this.currentSlideType = slide.type;

            /*
            * IMAGEN
            */
            if (slide.type === 'image') {

                this.splideInstance
                    ?.Components
                    ?.Autoplay
                    ?.play();

                return;
            }


            /*
            * YOUTUBE
            */
            if (slide.type === 'youtube') {

                /*
                * Pausar autoplay de Splide.
                */
                this.splideInstance
                    ?.Components
                    ?.Autoplay
                    ?.pause();


                /*
                * Puede suceder que YouTube
                * todavía esté cargando.
                */
                const player =
                    this.youtubePlayers[index];


                if (
                    !player ||
                    typeof player.playVideo !== 'function'
                ) {
                    return;
                }


                /*
                * Reiniciar video.
                */
                player.seekTo(
                    0,
                    true
                );


                player.mute();


                player.playVideo();
            }
        },


        /*
        |--------------------------------------------------------------------------
        | Pausar videos
        |--------------------------------------------------------------------------
        */

        pauseAllVideos() {

            Object.values(
                this.youtubePlayers
            ).forEach((player) => {

                if (
                    player &&
                    player.pauseVideo
                ) {

                    player.pauseVideo();

                }

            });
        },

    },

};
</script>


<style scoped>

.youtube-player {
    position: relative;

    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
    
    overflow: hidden;
}


/*
 * YouTube reemplaza el DIV por un iframe.
 */
.youtube-player :deep(iframe) {

    width: 100%;
    height: 100%;

    border: 0;

}


/*
 * Obligar a Splide a utilizar toda
 * la altura del Cover.
 */
:deep(.splide),
:deep(.splide__track),
:deep(.splide__list),
:deep(.splide__slide) {
    height: 100%;
}


</style>